export default __webpack_public_path__ + "src/images/galleries/2/btn_next-933ba5.png";